<template>
    <div v-if="customFields.length > 0">
        <h5 v-if="!disabledTitle">Thông tin tuỳ biến</h5>
        <div class="alert alert-danger" v-if="errorTxt">{{errorTxt}}</div>

        <div v-if="customFields && customFields.length" class="title-template-table table-responsive">
            <table class="table table-hover table-striped b-table-select-single">
                <thead>
                    <tr>
                        <th>Dữ liệu</th>
                        <th class="text-center">Ngày dễ phân hủy</th>
                        <th class="text-center">Ngày khó phân hủy</th>
                    </tr>
                </thead> 
                <tbody>
                    <tr v-for="field in customFields" :key="field.id">
                        <td>{{field.label}} <span v-if='field.required' class='text-danger' >*</span></td>
                        <td>
                <form-input v-if='customFieldsModel[field.key]' type="number" placeholder="Nhập khối lượng" class='mb-0'
                            :model="customFieldsModel[field.key]" attribute="easy" :errors="fieldErrors" :error-only="true" />
                </td>
                <td>
                <form-input v-if='customFieldsModel[field.key]' type="number" placeholder="Nhập khối lượng" class='mb-0'
                            :model="customFieldsModel[field.key]" attribute="hard" :errors="fieldErrors" :error-only="true" />
                </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            model: Object,
            attribute: {
                type: String,
                default: 'customFields'
            },
            disabledTitle: {
                type: Boolean,
                default: true
            },
            customFields: Array,
            type: String,
            errors: Object
        },
        data() {
            return {
                customFieldsModel: {},
                fieldErrors: {},
                errorTxt: null
            };
        },
        watch: {
            customFieldsModel: {
                handler() {
                    let model = [];
                    let errors = {};
                    this.customFields.forEach(field => {
                        if (this.customFieldsModel[field.key]) {
//                            if (val && val.length) {  
                            model.push(this.customFieldsModel[field.key]);
//                            } else {
//                                if (field.required) {
//                                    errors[field.key] = ["Bắt buộc nhập"];
//                                }
//                            }
                        } else {
                            if (field.required) {
                                errors[field.key] = ["Bắt buộc nhập"];
                            }
                        }
                    });
                    if (Object.keys(errors).length > 0) {
                        this.fieldErrors = errors;
                        this.model[this.attribute] = null;
                    } else {
                        this.model[this.attribute] = model;
                    }
                }, deep: true
            },
            errors(val) {
                if (val && Object.keys(val).length) {
                    Object.keys(val).forEach(key => {
                        if (key === this.attribute) {
                            this.errorTxt = val[key].join(";");
                        }
                    });
                }
            }
        },
        methods: {
            loadModel() {
                let model = {};
                this.customFields.forEach(field => {
                    let customField;
                    if (this.model[this.attribute]) {
                        customField = this.model[this.attribute].find(v => v.key === field.key);
                    }
                    if (customField) {
                        model[field.key] = customField;
                    } else {
                        model[field.key] = {
                            key: field.key,
                            number: null,
                            weight: null
                        };
                    }
                });
                this.customFieldsModel = model;
            }
        },
        mounted() {
            this.loadModel();
        }
    }
</script>
